import { motion } from "framer-motion";
import { UserRound, Briefcase, Users, Plane, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CARDS = [
  {
    icon: UserRound,
    title: "Personal Travel",
    body: "Comfortable transportation for everyday and long-distance journeys.",
  },
  {
    icon: Briefcase,
    title: "Business Travel",
    body: "Reliable mobility for professionals and corporate teams.",
  },
  {
    icon: Users,
    title: "Group Travel",
    body: "Premium transportation for teams, events and larger groups.",
  },
  {
    icon: Plane,
    title: "Airport Travel",
    body: "Seamless transfers designed around your schedule.",
  },
];

const ServiceCard = ({ item, index }) => {
  const Icon = item.icon;
  return (
    <Reveal delay={index * 0.09} data-testid={`service-card-${index + 1}`}>
      <motion.div
        whileHover={{ y: -6 }}
        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
        className="group relative h-full p-8 flex flex-col justify-between min-h-[280px] rounded-[8px] transition-colors duration-300"
        style={{
          background: "#151617",
          border: "1px solid rgba(201,163,91,0.28)",
        }}
      >
        <div className="absolute inset-0 rounded-[8px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
          style={{ boxShadow: "0 24px 60px -20px rgba(201,163,91,0.28)", border: "1px solid rgba(201,163,91,0.6)" }}
        />
        <div>
          <Icon size={30} strokeWidth={1.5} className="text-gold mb-10" />
          <h3 className="font-sans text-ivory font-semibold text-lg mb-4">{item.title}</h3>
          <p className="font-sans text-ivory/50 text-sm leading-relaxed max-w-[240px]">
            {item.body}
          </p>
        </div>
        <ArrowUpRight
          size={22}
          strokeWidth={1.5}
          className="text-gold mt-8 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </motion.div>
    </Reveal>
  );
};

export const MobilityServices = () => (
  <section
    id="services"
    data-testid="mobility-services"
    className="bg-dark py-16 sm:py-24 lg:py-[132px]"
  >
    <div className="container-bettr">
      <div className="flex flex-col items-center text-center mb-16 lg:mb-20">
        <Reveal>
          <Eyebrow chapter="02" className="justify-center">
            For Every Journey
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif font-normal text-white mt-6 text-[42px] sm:text-[56px] lg:text-[66px] leading-none tracking-[-0.02em]">
            Mobility, <span className="italic text-gold">your way.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CARDS.map((c, i) => (
          <ServiceCard key={c.title} item={c} index={i} />
        ))}
      </div>
    </div>
  </section>
);
